<template>
  <Dashboard v-if="isAuthenticated" />
  <Login v-else />
</template>

<script>
// @ is an alias to /src
import Login from "@/views/Login";
import Dashboard from "@/views/Dashboard";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    Login,
    Dashboard
  },
  computed: {
    ...mapGetters([ 'isAuthenticated']),
  },
};
</script>
